// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/views/jobs/searches/MatchingConsentCard.js
//
// Consentement du membre au rapprochement de ses recherches avec les offres d'emploi (lot 4).
// Désactivé par défaut, retirable à tout moment. L'interface propose, le SERVEUR décide : sans
// consentement actif, l'API refuse (403) quoi que fasse cet écran.

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CCard, CFormSwitch, CSpinner } from '@coreui/react'
import { formatDateI18n } from '../../../utils/i18nFormatters'
import './searches.scss'

/**
 * @param {{consent: ({enabled: boolean, consentedAt: (string|null)}|null), onChange: (enabled: boolean) => Promise<void>}} props
 *   consent = null tant que l'état n'est pas chargé (rien n'est affiché comme activé).
 */
const MatchingConsentCard = ({ consent, onChange }) => {
  const { t, i18n } = useTranslation()
  const [saving, setSaving] = useState(false)

  if (!consent) return null
  const enabled = Boolean(consent.enabled)

  const toggle = async (event) => {
    if (saving) return
    setSaving(true)
    try {
      await onChange(event.target.checked)
    } finally {
      setSaving(false)
    }
  }

  return (
    <CCard className="ms-consent aw-elev-1">
      <div className="ms-consent-head">
        <h6 className="ms-consent-title">{t('searches:matching.consent.title')}</h6>
        <div className="ms-consent-switch">
          {saving && <CSpinner size="sm" />}
          <CFormSwitch
            id="ms-matching-consent"
            checked={enabled}
            disabled={saving}
            onChange={toggle}
            label={t('searches:matching.consent.toggle')}
          />
        </div>
      </div>
      <p className="ms-consent-body">{t('searches:matching.consent.body')}</p>
      <p className="ms-note mb-0">
        {enabled && consent.consentedAt
          ? t('searches:matching.consent.since', {
              date: formatDateI18n(consent.consentedAt, 'P', i18n.language),
            })
          : t('searches:matching.consent.off_hint')}
      </p>
    </CCard>
  )
}

export default MatchingConsentCard
